import { useEffect, useRef, useState } from "react";

export const useScroll = () => {
  const scrollRef = useRef<HTMLDivElement | null>(null);
  const contactRef = useRef<HTMLDivElement | null>(null);
  const [showScrollTop, setShowScrollTop] = useState(false);

  const scrollToTop = () => {
    scrollRef.current?.scrollTo({ top: 0, behavior: "smooth" });
  };

  const scrollToContact = () => {
    if (contactRef.current && scrollRef.current) {
      const scrollContainer = scrollRef.current;
      const contactElement = contactRef.current;
      const containerRect = scrollContainer.getBoundingClientRect();
      const contactRect = contactElement.getBoundingClientRect();

      const scrollTop =
        scrollContainer.scrollTop + (contactRect.top - containerRect.top);

      scrollContainer.scrollTo({
        top: scrollTop,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    const onScroll = () => {
      setShowScrollTop(el.scrollTop > 300);
    };

    el.addEventListener("scroll", onScroll);
    return () => el.removeEventListener("scroll", onScroll);
  }, []);

  return {
    scrollRef,
    contactRef,
    scrollToTop,
    scrollToContact,
    showScrollTop,
  };
};
